
import { Button } from "../../../../components/ui/button";
import { setBotSettings } from "../../../lib/SessionSlice";
import { useDispatch, useSelector } from "react-redux";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../../components/ui/tooltip"
import { IoMdHelpCircle } from "react-icons/io";
import React, { useEffect } from "react";
import { lazy } from "react";
import { Suspense } from "react";
import { useWallet } from "@solana/wallet-adapter-react";


const Checker = lazy(() => import('./Checker'))

export default function UserInputs({ children, started, tradingActive, className }) {

  const {publicKey}= useWallet()


  const dispatch = useDispatch()
  const session = useSelector(state => state.session)

  const botSettings = session.bot


  useEffect(()=>{
    if (publicKey) {
      setSettings({
        address:publicKey?.toBase58()
      })
    }

  },[publicKey])


  const setSettings = (data) => dispatch(setBotSettings(data))

  const setRecomandedSettings = () => {
    setSettings({
      address: "",
      secret: "",
      maxOpenTrades: 5,
      marketCap: 28,
      sellMc: 3,
      amount: 0.005,
      ownerTokenHoldings: 10,
      stopLoss: 3,
      slippage: 7,
      priorityfee: 0.00005,

    })
  }


  const handleUserInput = ({ target }) => {
    const { name, value } = target
    setSettings({ [name]: value })
  }


  const checkFileds = () => {
    if (botSettings?.amount == "" || botSettings?.maxOpenTrades == "" || botSettings?.secret == "" || botSettings?.marketCap == "" || botSettings?.sellMc == "" || botSettings?.ownerTokenHoldings == '' || botSettings?.stopLoss == "") {
      return false
    } else {
      return true
    }
  }




  return (

    <>
      <TooltipProvider>
        {
          <div className={` grid  space-y-2  ${className} w-full `}>


            <div className={`flex w-full   gap-5  p-5 border  rounded shadow ${started ? 'bg-green-100' : 'bg-gradient-to-tl from-neutral-900 to-transparent border-yellow-500/10'}`}>


              <div className=" flex  gap-5 justify-between w-full flex-wrap md:flex-nowrap  ">
                <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 justify-around w-full">


                  <div className="flex flex-col gap-2 grow w-full  ">
                    <div className="flex items-center gap-2">
                      <p className="text-xs font-bold text-neutral-500 ">* Amount To buy</p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">Amount of Solana that Bot buys each Trade</p>
                        </TooltipContent>
                      </Tooltip>
                    </div>
                    <input value={botSettings?.amount} className="bg-neutral-800 outline-none focus:ring-1   
                   placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" disabled={tradingActive} name='amount' placeholder='0.1 SOL' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">Amount of SOL To buy each trade</p>

                  </div>
                  {/* <div className="flex flex-col gap-2 grow  ">
                    <div className="flex items-center gap-2">
                      <p className="text-xs font-bold text-neutral-500">* Max Trades</p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">Maximum simultaneous trades bot opens , bot will not fill additional positions until previous one is closed</p>
                        </TooltipContent>
                      </Tooltip>
                    </div>

                    <input value={botSettings?.maxOpenTrades} className="bg-neutral-800 outline-none focus:ring-1   
                    
                    placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" disabled={tradingActive} name='maxOpenTrades' placeholder='5 trades' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">Max opening trades</p>

                  </div> */}
                  <div className="flex flex-col gap-2 grow ">

                    <p className="text-xs font-bold text-neutral-500">wallet Public</p>
                    <input className="bg-neutral-800 outline-none focus:ring-1   
                      placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed"  value={botSettings?.address} name='address' placeholder='Your wallet address' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">your wallet address</p>

                  </div>
                  <div className="flex flex-col gap-2 grow ">

                    <p className="text-xs font-bold text-red-500">* wallet Secret</p>
                    <input type="password" className="bg-neutral-800 outline-none focus:ring-1   
                        placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" value={botSettings.secret} disabled={tradingActive} name='secret' placeholder='AArPXm8JatJiuyEffuC1un2Sc835SULa4uQqDcaGpAjV' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">your wallet Private Key</p>

                  </div>
                  <div className="flex flex-col gap-2 grow ">

                    <div className="flex gap-2 items-center">
                      <p className="text-xs font-bold text-neutral-500">* Buying MarketCap </p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">Minimum MarketCap the bot will try to filter Good Projects From</p>
                        </TooltipContent>
                      </Tooltip>
                    </div>
                    <input value={botSettings?.marketCap} className="bg-neutral-800 outline-none focus:ring-1   
                        placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" disabled={tradingActive} name='marketCap' placeholder='30' onChange={handleUserInput} />

                    <p className="text-xxs font-bold text-neutral-500 ">MC w hich bot Buys At</p>


                  </div>
                  <div className="flex flex-col gap-2 grow ">

                    <div className="flex gap-2 items-center">
                      <p className="text-xs font-bold text-neutral-500">* Selling MarketCap</p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">Minimum MarketCap bot will sell At , Please Note that this Number will Be added To the MarketCap that The bot Buys At , per example bot buys a coin at 50MC , sell MC is set to 5 , bot will trigger the Sell when it reaches 55MC but will sell at the peak MC</p>
                        </TooltipContent>
                      </Tooltip>
                    </div>


                    <input value={botSettings?.sellMc} className="bg-neutral-800 outline-none focus:ring-1   
                  placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" disabled={tradingActive} name='sellMc' placeholder='50' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">MC which Bot Sells AT</p>

                  </div>

                  <div className="flex flex-col gap-2 grow ">
                    <div className="flex gap-2 items-center">
                      <p className="text-xs font-bold text-neutral-500 ">* Max Token Holdings</p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">The bot Will Ignore projects which owner's wallet has more percentage than this amount </p>
                        </TooltipContent>
                      </Tooltip>
                    </div>
                    <input value={botSettings?.ownerTokenHoldings} className="bg-neutral-800 outline-none focus:ring-1   
                     placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed" disabled={tradingActive} name='ownerTokenHoldings' placeholder='2' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">max tokens in owner's wallet</p>

                  </div>
                  <div className="flex flex-col gap-2 grow ">
                    <div className="flex gap-2 items-center">
                      <p className="text-xs font-bold text-neutral-500 ">Stop Loss</p>
                      <Tooltip>
                        <TooltipTrigger asChild><IoMdHelpCircle className="text-neutral-400 " /></TooltipTrigger>
                        <TooltipContent>
                          <p className="text-neutral-400">Stop Loss in terms of MC , example : if bot buys a token at 50MC  and SL is set to 5 , the SL is 50-5 which is 45 SOL </p>
                        </TooltipContent>
                      </Tooltip>
                    </div>
                    <input className="bg-neutral-800 outline-none focus:ring-1   
                         placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed " disabled={tradingActive} name='stopLoss' value={botSettings?.stopLoss} placeholder='2 ' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">your Stop Loss</p>

                  </div>

                  <div className="flex flex-col gap-2 grow ">

                    <p className="text-xs font-bold text-neutral-500">Slippage</p>
                    <input className="bg-neutral-800 outline-none focus:ring-1   
                 placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed"  value={botSettings?.slippage} name='slippage' placeholder='5%' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">slippage</p>

                  </div>

                  <div className="flex flex-col gap-2 grow ">

                    <p className="text-xs font-bold text-neutral-500">Priority fee</p>
                    <input className="bg-neutral-800 outline-none focus:ring-1   
                      placeholder:text-xs text-xs text-neutral-400 rounded-md w-full h-8 placeholder:text-neutral-600 px-2 focus:ring-yellow-600 disabled:cursor-not-allowed"  value={botSettings?.priorityfee} name='priorityfee' placeholder='0.00001' onChange={handleUserInput} />
                    <p className="text-xxs font-bold text-neutral-500 ">priority fees</p>

                  </div>

                  <div className="flex flex-col gap-2 grow justify-start">

                    <p className="text-xxs font-bold text-neutral-500 ">set recommended settings</p>
                    <Button disabled={tradingActive} onClick={setRecomandedSettings} className="bg-yellow-500 hover:bg-yellow-400 text-black disabled:bg-neutral-300  " >set Settings</Button>


                  </div>

                </div>



                {children}
              </div>

            </div>
            {/* {!checkFileds() && <p className="text-red-500 text-xs  ">All the fields with * are mandatory and required </p>} */}
            <Suspense fallback={"loading ..."} >
              <div className="flex gap-2 items-center">
                <p className="text-xs text-neutral-200 ">check Twitter</p>
                <Checker name={"twitter"} />
                <p className="text-xs text-neutral-200 ">check Telegram</p>
                <Checker name={"telegram"} />
                <p className="text-xs text-neutral-200 ">check website</p>
                <Checker name={"website"} />
              </div>
            </Suspense>
            <p className="text-xs text-yellow-500 ">slightly affects speed but more advanced scam filtering </p>
          </div>
        }
      </TooltipProvider>
    </>


  )

}